import React from 'react';

export default function CrmChatReplyQuote({ replyTo, isMine, onClick }) {
  if (!replyTo) return null;

  const available = replyTo.available !== false;
  const preview = available
    ? (replyTo.body_preview || replyTo.body || (replyTo.message_type === 'image' ? 'Photo' : 'Document'))
    : 'Original message unavailable.';

  return (
    <button
      type="button"
      onClick={() => available && onClick?.(replyTo.id)}
      className={`w-full text-left mb-1.5 px-2 py-1.5 rounded-lg border-l-[3px] text-xs transition-colors ${
        isMine
          ? 'bg-emerald-700/40 border-emerald-300 hover:bg-emerald-700/55'
          : 'bg-background/50 border-emerald-500 hover:bg-background/70'
      } ${available ? 'cursor-pointer' : 'cursor-default opacity-80'}`}
    >
      <div className={`font-semibold truncate ${isMine ? 'text-emerald-100' : 'text-emerald-600'}`}>
        {replyTo.sender_name || 'User'}
      </div>
      <div className={`truncate ${isMine ? 'text-emerald-50/90' : 'text-muted-foreground'}`}>
        {preview}
      </div>
    </button>
  );
}
